var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 5H9M5 1V9","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconPlus.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
